import jwtDecode from 'jwt-decode'
import Cookies from 'js-cookie'

const SET_TOKEN = 'SET_TOKEN'
const CLEAR_TOKEN = 'CLEAR_TOKEN'
const FLASH_TOKEN = 'FLASH_TOKEN'
const SET_TITLE = 'SET_TITLE'
const SET_ROLE = 'SET_ROLE'
// const SET_PICTURE = 'SET_PICTURE'

// eslint-disable-next-line no-unused-vars
// const COOKIE_EXPIRED = process.env.VUE_APP_COOKIE_EXPIRED
// const COOKIE_DOMAIN = process.env.VUE_APP_COOKIE_DOMAIN
const COOKIE_SUFFIX = process.env.VUE_APP_COOKIE_SUFFIX

const JWT_TOKEN = `JWT_TOKEN${COOKIE_SUFFIX}`

export default {
    state: {
        id: '',
        userid: '',
        username: '',
        email: '',
        exp: 0,
        role: '',
        JWT_TOKEN: ''
    },
    getters: {
        isLogin: state => {
            return state.JWT_TOKEN !== ''
        },
        userName: state => {
            return state.username
        },
        userid: state => {
          return state.userid || state.id
        },
        userRole: state => {
          return state.role
        }
    },
    mutations: {
        [SET_TOKEN](state, token) {
            let decoded = jwtDecode(token)
            let exp = decoded.exp || 0
            let EXPIRED = new Date(new Date().getTime() + exp)
            Cookies.set(JWT_TOKEN, token, {
                expires: EXPIRED
            })
            localStorage.token = token
            state.userid = decoded.user_id
            state.role = decoded.role
            state.username = decoded.username || ''
            state.exp = decoded.exp || 0
            state.JWT_TOKEN = token
        },
        [CLEAR_TOKEN](state) {
            state.userid = ''
            state.username = ''
            state.exp = 0
            state.role = ''
            state.JWT_TOKEN = ''
            localStorage.removeItem('token')
            Cookies.remove(JWT_TOKEN)
            //清除存储
        },
        [FLASH_TOKEN](state) {
            let token = Cookies.get(JWT_TOKEN)
            state.JWT_TOKEN = token || ''
            if (token) {
                let decoded = jwtDecode(token)
                console.log(decoded)
                state.userid = decoded.user_id
                state.role = decoded.role
                state.username = decoded.username || ''
                state.exp = decoded.exp || 0
                state.JWT_TOKEN = token || ''
            }
        },
        [SET_ROLE](state, role){
            state.role = role
        },
        [SET_TITLE](state, title) {
            state.title = title
        }
        // [SET_PICTURE](state,picture){
        //     state.picture = picture
        // }
    },
    actions: {}
}
